<template>
    <div class="router-info">
        <header>
            <button
				class="_approve"
				:disabled="loading"
				@click="$emit('save')"
			>Save</button>
        </header>

        <section>
            <div class="tabs">
                <div 
                    v-for="(item, index) in ['01 Register router', '02 Assign Account']" 
                    :key="index" 
                    class="tab box" :class="{ 'active' : registerTab === index }" 
                    @click="changeRegisterTab(index)"
                >
                    {{ item }}
                </div>
            </div>

            <div class="tab-content" v-if="registerTab === 0">
                <div class="form-container box">
                    <header>
                        <h3>
                            Register Router
                        </h3>
                    </header>

                    <form @submit.prevent="$emit('submit')">

                        <InputField
                            class="input-box"
                            :limit="50"
                            label="Router Name"
                            placeholder="Enter Router Name"
                            v-model="formData.name"
                            required
                        />

                        <InputField
                            class="input-box"
                            :limit="15"
                            label="Router IP Address"
                            placeholder="192.168.40.1"
                            v-model="formData.ipAddress"
                            required
                        />

                        <InputField
                            class="input-box"
                            :limit="17"
                            label="Router MAC Address"
                            placeholder="CC:1B:E0:E0:E9:10"
                            v-model="formData.macAddress"
                            required
                        />
                    </form>
                </div>

                <div class="box">
                    <header>
                        <h3>Add Upmood Bands</h3>

                        <nav>
                            <ul>
                                <li 
                                    v-for="(item, index) in ['Input', 'Scan']" 
                                    :key="index" 
                                    :class="{'active' : addBandTab === index}"
                                    @click="changeBandTab(index)"
                                >
                                    {{ item }}
                                </li>
                            </ul>
                        </nav>
                    </header>

                    <template  v-if="addBandTab === 0">
                        <form class="band-container" v-for="(item, index) in formData.bands" :key="index">
                            <InputField
                                class="input-box"
                                :limit="50"
                                :label="'Band Name'"
                                :placeholder="'Enter Band Name'"
                                v-model="formData.bands[index].name"
                            />

                            <InputField
                                class="input-box"
                                :limit="50"
                                label="Band MAC Address"
                                placeholder="CC:1B:E0:E0:E9:10"
                                v-model="formData.bands[index].macAddress"
                            />

                            <span
                                class="remove"
                                @click="$emit('remove-band', {item, index})"
                            >
                                &times;
                            </span>
                        </form>
                        
                        <div class="controls">
                            <input type="number" v-model.number="addBandCount">
                            <button class="_approve" @click="addBand">Add Band</button>
                        </div>
                    </template>

                    <div class="scan-container" v-if="addBandTab === 1">
                        <div class="scanning">
                            <div class="loading" v-if="scanning">
                                <RadarLoading>
                                    <!-- <a @click.prevent="scanning = false">Stop</a> -->
                                </RadarLoading>
                            </div>

                            <button
                                class="_approve"
                                :class="{'_approve--scan': items.length}"
                                v-else
                                @click="scan">
                                Scan Band
                            </button>

                            <custom-table
                                class="scanned"
                                key-field="mac"
                                :fields="fields"
                                :items="items"
                                :has-pagination="false"
                                :isLoading="false"
                                :class="{'disable': false}"
                                :isSelectable="false"
                                v-if="scanning || items.length"
                            >
                                <template slot="actions" slot-scope="{item}">
                                    <a @click="add(item)" class="ok" v-if="!formData.bands.filter(i => i.macAddress === item.macAddress).length">&#43;</a>
                                    <a @click="remove(item.macAddress)" class="cancel" v-else>&#8722;</a>
                                </template>
                            </custom-table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-content" v-if="registerTab === 1">
                <div class="box">
                    <header>
                        <h3>Assign Account</h3>
                    </header>

                    <form>
                        <SelectField
                            class="select-box"
                            :label="'Host Account Name'"
                            placeholder="Account Name"
                            displayProp="full_name"
                            valueProp="full_name"
                            idProp="id"
                            :disabled="clientListLoading"
                            :items="clientList"
                            v-model="formData.client"
							deselect
                            custom-search
                            @search="getClientList"
                        />

                        <InputField
                            class="input-box"
                            :label="'Host Email'"
                            v-model="formData.client.host_email"
                            disable
                        />

                        <InputField
                            class="input-box"
                            :label="'Host Company Email'"
                            v-model="formData.client.email"
                            disable
                        />

                        <InputField
                            class="input-box"
                            :label="'Host Company Name'"
                            v-model="formData.client.company_name"
                            disable
                        />
                    </form>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import InputField from '@/components/utils/InputField.vue'
import CustomTable from '@/components/utils/CustomTable.vue'
import RadarLoading from '@/components/utils/RadarLoading.vue'
import SelectField from '@/components/utils/SelectField'

export default {
    data () {
        return {
            addBandTab: 0,
            addBandCount: 1,

            fields: [
                { text: 'Name', name: 'name' },
                { text: 'Mac Address', name: 'macAddress' },
            ],

            items: [],
            source: null
        }
    },

    computed: {
		...mapFields(`router`, {
			loading: 'buttonLoading',
            formData: 'createForm',
            clientList: 'clientList',
            clientListLoading: 'clientListLoading',
			registerTab: 'registerTab',
			scanning: 'scanning'
		}),
    },

    destroyed () {
		if (this.source) {
			this.source.close()
		}
	},

    methods: {
		changeRegisterTab (index) {
			if (this.scanning && index === 1) {
				this.$store.commit('modal/toggleNotification', {
					notificationName: 'notification-banner',
					notificationType: 'warning',
					notificationDesc: 'Please wait for the band scanning to stop.'
				})
				return
			}

			this.registerTab = index
		},

		changeBandTab (index) {
			if (this.scanning && index === 0) {
				this.$store.commit('modal/toggleNotification', {
					notificationName: 'notification-banner',
					notificationType: 'warning',
					notificationDesc: 'Please wait for the band scanning to stop.'
				})
				return
			}

			this.addBandTab = index
		},

        getClientList (keyword) {
            clearTimeout(this.timeout)
			this.timeout = setTimeout(() => {
				let apiQuery = ''

				if (keyword) {
					apiQuery = `?keyword=${keyword}`
				}

                this.$store.dispatch('router/getClientList', apiQuery)
			}, 500)
        },

        addBand () {
            while(this.addBandCount > 0) {
				const band = {
					name: '',
					macAddress: '',
					created_at: new Date()
				}
                this.formData.bands.unshift(band)
                this.addBandCount--
            }

            this.addBandCount = 1
        },

        add (item) {
            const { bands } = this.formData

            if (bands.length === 1 && 
                (bands[0].name.trim() === '' ||
                bands[0].macAddress.trim() === '')) {

                bands[0].name = item.name
                bands[0].macAddress = item.macAddress
                return
            }

            bands.unshift(Object.assign({}, item))
        },

        remove (macAddress) {
            const index = this.formData.bands
                            .findIndex(band => band.macAddress === macAddress)
            this.formData.bands.splice(index, 1)
        },

        async scan () {
            if (this.formData.macAddress === '' ||
                this.formData.ip === '' ) {
                this.$store.commit('modal/toggleNotification', {
                    notificationName: 'notification-banner',
                    notificationType: 'warning',
                    notificationDesc: 'Please enter MAC Address and IP Address'
                })
                return
			}

			clearTimeout(this.timeout)
			this.timeout = setTimeout(() => {
                this.scanning = false
                this.source.close()
			}, 30000)

			if (window.EventSource) {
                const { ipAddress, macAddress } = this.formData
				this.items = []
                this.scanning = true
                // Yes! Server-sent events support!
				this.source = new EventSource(`https://${ipAddress}/gap/nodes/?mac=${macAddress}&access_token=&active=1&event=1&chip=0`)

				this.source.addEventListener('message', async (e) => {
                    const res = JSON.parse(e.data)
                    const { bdaddr } = res.bdaddrs[0]
                    const isIncluded = this.items.some(band => band.macAddress === bdaddr)
                    const isVibeTracker = res.name.toLowerCase().startsWith('spiral')
                    const isUpmoodBand = res.name.toLowerCase().startsWith('upmood')
                    const isUpmoodWatch = res.name.toLowerCase().startsWith('up')

                    if (! isIncluded && (isUpmoodBand || isUpmoodWatch || isVibeTracker) ) {
                        this.items.push({
                            macAddress: bdaddr,
                            name: res.name
                        })
                    }

				}, false)

				this.source.addEventListener('open', () => {
					// Connection was opened.
					console.log('Open connection')
				}, false)

				this.source.addEventListener('error', (e) => {
					if (e.readyState === EventSource.CLOSED) {
						// Connection was closed.
						console.log('Close connection')
                        this.scanning = false
					}
				}, false)
			}
        }
    },

    components: {
        InputField,
        CustomTable,
        RadarLoading,
        SelectField
    }
}
</script>

<style lang="scss" scoped>
.router-info {
    max-width: 850px;

    > header {
        text-align: right;
        padding: 10px;

        button {
            width: 80px;
        }
    }

    section {
        margin-left: 100px;
        display: flex;
        
        .box {
            background-color: #fff;
            box-shadow: 0 0 20px #E6EAF2;
            padding: 30px;
        }

        .tabs, .tab-content {
            padding: 10px;

            .tab {
                padding: 25px 10px;
                background-color: #fff;
                box-shadow: 0 0 20px #E6EAF2;
                margin-bottom: 20px;
                width: 200px;
                opacity: 0.3;
                transition: 0.3s;
                cursor: pointer;

                &.active, &:hover {
                    opacity: 1;
                    color: #2DC4B6;
                }
            }
        }

        .tab-content {
            flex: 1 1 auto;

            header {
                margin-bottom: 20px;
                border-bottom: 1px solid #E6EAF2;

                h3 {
                    margin-bottom: 20px;
                }
            }

            form > * {
                margin-bottom: 20px;
            }

            .box {
                margin-bottom: 20px;
            }
        }
    }

    nav {
        width: 100%;

        ul {
            display: flex;
            list-style: none;

            li {
                text-align: left;
                border-bottom: 1px solid transparent;
                margin-right: 20px;
                cursor: pointer;
                transition: 0.3s;

                &.active {
                    border-color: #2DC4B6;
                    color: #2DC4B6;
                }
            }
        }
    }

    .band-container {
        width: 100%;
        position: relative;

        span.remove {
            position: absolute;
            top: 5px;
            right: 10px;
            color: #F44B4B;
            cursor: pointer;
            font-size: 20px;
        }

        .input-box {
            flex: 1 1 auto;
            margin-right: 10px;
        }
    }

    .controls {
        display: flex;
        justify-content: flex-end;

        input[type=number] {
            width: 50px;
            text-align: center;
            border: 1px solid #aaa;
            margin-right: 5px;
        }
    }

    .scan-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        min-height: 300px;
        min-width: 50%;
        position: relative;

        h4 {
            justify-self: flex-start;
        }

        .scanning {
            height: 300px;
        }

        .loading {
            position: absolute;
            z-index: 9;
            background-image: radial-gradient(#7ac0b98f, #fafafa62);
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            a {
                font-size: 2rem;
                color: #fff;
                cursor: pointer;
            }
        }

        button {
            margin-bottom: 10px;
        }

        a {
            cursor: pointer;
            
            &.ok, &.cancel {
                font-size: 2rem;
            }
            
            &.ok {
                color: #0CBA6A;
            }

            &.cancel {
                color: #E71D36;
            }
        }

    }
}
</style>